import type {
  IdentifyPayload,
  TrackEventsBatch,
  TrackEventsBatchResponse,
} from './types';

async function post(url: string, body: unknown): Promise<Response> {
  return fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
    keepalive: true,
  });
}

/**
 * Posts a batch to /tracking/events.
 * Returns the parsed response on success, null on any failure.
 * Errors are intentionally swallowed — tracking must never break the host page.
 */
export async function postBatch(
  apiBaseUrl: string,
  batch: TrackEventsBatch,
): Promise<TrackEventsBatchResponse | null> {
  try {
    const res = await post(`${apiBaseUrl}/tracking/events`, batch);
    if (!res.ok) return null;
    return (await res.json()) as TrackEventsBatchResponse;
  } catch {
    return null;
  }
}

/**
 * Posts an identify call to /tracking/identify.
 * Errors are intentionally swallowed.
 */
export async function postIdentify(
  apiBaseUrl: string,
  payload: IdentifyPayload,
): Promise<void> {
  try {
    await post(`${apiBaseUrl}/tracking/identify`, payload);
  } catch {
    // no-op
  }
}
